/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 */

import MarkdownPage from 'components/MarkdownPage';
import React from 'react';
import {graphql} from 'gatsby';
import Layout from 'components/Layout';
import {createLinkArticoli} from 'utils/createLink';
import {sectionListArticoli} from 'utils/sectionList';
import VisitArticoli from '../components/Apis/visit-articoli';

const Articoli = ({data, location}) => (
  <Layout location={location}>
    <VisitArticoli />
    <MarkdownPage
      createLink={createLinkArticoli}
      location={location}
      markdownRemark={data.markdownRemark}
      sectionList={sectionListArticoli}
      titlePostfix=" &ndash; Milani"
    />
  </Layout>
);

export const pageQuery = graphql`
  query TemplateArticoliMarkdown($slug: String!) {
    markdownRemark(fields: {slug: {eq: $slug}}) {
      html
      frontmatter {
        title
        next
        prev
      }
      fields {
        path
        slug
      }
    }
  }
`;

export default Articoli;
